module.exports = __webpack_public_path__ + "static/media/close-icon.8ef59ad4.svg";